export default {
    generateContentModal: {
        title: 'Content Maken',
        type: 'Type',
        typePlaceholder: 'Selecteer type',
        typeEmptyError: 'Selecteer het type',
        context: 'Context',
        contextPlaceholder: 'Selecteer context',
        contextEmptyError: 'Selecteer de context',
        contentTitle: 'Content titel',
        contentTitlePlaceholder: 'Voeg het thema van uw content toe',
        contentTitleEmptyError: 'Vul de titel in',
        contentTitleInvalidError: 'Vul een geldige titel in aub',
        contentTitleNumberError: 'Voer alstublieft een titel in die begint met een letter',
        description: 'Geef een korte inhoudsbeschrijving',
        descriptionPlaceholder: 'Voeg de beschrijving van uw conent toe in 2-3 regels',
        descriptionEmptyError: 'Vul de beschrijving in aub',
        descriptionInvalidError: 'Vul een geldige beschrijving in aub',
        addKeywords: 'Voeg trefwoorden toe',
        addKeywordsEmptyError: 'Vul aub de treftwoorden in',
        writingTone: 'Schrijftoon',
        writingTonePlaceholder: 'Kies de schrijftoon',
        writingToneEmptyError: 'Selecteer de schrijftoon aub',
        numberOfVariations: 'Aantal variaties',
        numberOfVariationsEmptyError: 'Selecteer het aantal variaties aub',
        numberOfVariationsInvalidError: 'U kunt maximaal 5 en minimaal 1 variatie genereren',
        generate: 'Genereren',
        additionalOptions: 'Extra opties',
        clear: 'Duidelijk',
        writingToneOptions: {
            funny: 'Grappig',
            casual: 'Informeel',
            excited: 'Enthousiast',
            professional: 'Professioneel',
            witty: 'Geestig',
            sarcastic: 'Sarcastisch',
            feminine: 'Vrouwelijk',
            masculine: 'Mannelijk',
            bold: 'Gedurfd',
            dramatic: 'Dramatisch',
            grumpy: 'Mopperig',
            secretive: 'Geheimzinnig',
            respectful: 'Respectvol',
            persuasive: 'Overtuigend',
        },
        contextOptions: {
            promotional: 'Promotioneel',
            introduction: 'Introductie',
            couponDiscount: 'Coupon/Korting',
            recurringNewsletter: 'Terugkerende nieuwsbrief',
            testimonial: 'Getuigenis',
            coldOutreach: 'Koude acquisitie',
            contentGiveaway: 'Content/Giveaway',
            other: 'Andere',
        },
        typeOptions: {
            outline: 'Schets',
            introduction: 'Introductie',
            section: 'Sectie',
        },
        customLengthOfContentPlaceholder: 'Número de palavras (máx. 900)',
        lengthOfContentPlaceholder: 'Selecione o tamanho do conteúdo',
        lengthOfContent: 'Comprimento do conteúdo',
        customLengthOfContent: 'Aangepaste lengte',
        smallContent: 'Pequeno',
        mediumContent: 'Medium',
        largeContent: 'Groot',
        customContentLength: 'Comprimento personalizado (50 a 900 palavras)',
        lengthOfContentError: 'Selecteer alstublieft de lengte van de inhoud',
        customLengthError: 'Valor incorreto',
        lengthOfContentTooltip: 'Stel de lengte van de inhoud in die wordt gegenereerd op basis van de beschrijving van de prompts',
    },
};
